"use client";

import * as React from "react";

import { Skeleton } from "./skeleton";

export function SatelliteRouteLoading({
  variant = "public",
}: {
  variant?: "public" | "admin";
}) {
  const [slow, setSlow] = React.useState(false);

  React.useEffect(() => {
    window.dispatchEvent(new Event("satellite-loading-ui"));
    const timer = setTimeout(() => setSlow(true), 10_000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      data-satellite-route-loading={variant}
      aria-busy="true"
      aria-live="polite"
      className="min-h-[60vh] bg-[var(--brand-background)] p-6"
    >
      <span className="sr-only">
        {slow ? "This page is taking longer than expected." : "Loading page."}
      </span>
      <div className="mx-auto max-w-6xl motion-reduce:[&_[data-slot=skeleton]]:animate-none">
        <Skeleton className="h-8 w-56" />
        <Skeleton className="mt-3 h-4 w-80 max-w-full" />
        <div
          className={
            variant === "admin"
              ? "mt-8 grid gap-4 sm:grid-cols-3"
              : "mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
          }
        >
          {Array.from({ length: variant === "admin" ? 3 : 6 }).map((_, index) => (
            <Skeleton key={index} className="h-40 rounded-xl" />
          ))}
        </div>
        {slow ? (
          <div
            className="mt-8 rounded-lg border p-4"
            style={{ borderColor: "var(--brand-card-border)" }}
            role="status"
          >
            <p className="text-sm">This page is taking longer than expected.</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-3 min-h-11 rounded-md border px-4 py-2 text-sm font-medium"
              style={{ borderColor: "var(--brand-card-border)" }}
            >
              Retry
            </button>
          </div>
        ) : null}
      </div>
    </section>
  );
}
